module.exports = __webpack_public_path__ + "img/phone-app-hand.8eb82a32.jpg";